import DigitalColorBlock from "../../screens/logo-editor/componenets/DigitalColorBlock";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

interface DigitalColorElementProps {
  showText?: boolean;
  text?: string;
}

export function DigitalColorElement({
  showText = true,
  text,
}: DigitalColorElementProps) {
  const { t } = useTranslation();
  const displayText = text ?? t("compLogoDesign.digital");

  const content = (
    <div className={"flex items-center space-x-1"}>
      <DigitalColorBlock size={"sm"} />
      {showText && <p>{displayText}</p>}
    </div>
  );

  if (!showText) {
    return (
      <Tooltip title={displayText} placement={"right"}>
        {content}
      </Tooltip>
    );
  }

  return content;
}
